<!-- favorite content -->
@if (!isLoading) {
  @if (favoritesData.length > 0) {
    <!-- favorites list -->
    <ul class="favorite-box__content">
      @for (favorite of favoritesData; track favorite.title) {
        <li>
          @switch (currentTab) {
            @case ('products') {
              <pwj-product-card
                [productCardData]="favorite"
                [isFavoriteMode]="true"
                [simpleBorder]="true"></pwj-product-card>
            }
          }
        </li>
      }
    </ul>
  } @else {
    <!-- no content component -->
    <pwj-no-content [message]="noContentMessage | translate"></pwj-no-content>
  }
} @else {
  <!-- skeleton components -->
  @switch (currentTab) {
    @case ('products') {
      <div>
        <pwj-product-card-skeleton
          [count]="6"
          containerClasses="mt-10 grid grid-cols-1 gap-x-4 gap-y-8 sm:grid-cols-2 sm:gap-x-6 lg:grid-cols-3"></pwj-product-card-skeleton>
      </div>
    }
  }
}
